import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DepartmentDto } from "../../autogen/bff-api";
import { useProcurementTerms } from "../terminology/useProcurementTerms";

interface Props {
  isOpen: boolean;
  departments: DepartmentDto[];
  isCreating: boolean;
  onCancel: () => void;
  onConfirm: (departmentId: string) => void;
  wording?: { title: string; question: string; noDepartment: string };
}

export const ChooseEventDepartmentModal = ({ isOpen, departments, isCreating, onCancel, onConfirm, wording }: Props) => {
  const { t } = useTranslation();
  const terms = useProcurementTerms();
  const { title, question, noDepartment } = wording ?? {
    title: terms.newProcurement,
    question: terms.whichDepartmentOwnsProcurement,
    noDepartment: terms.cannotCreateProcurementInAnyDepartment,
  };
  const [selected, setSelected] = useState<string>(departments[0]?.id ?? "");

  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {departments.length === 0 ? (
            <Text>{noDepartment}</Text>
          ) : (
            <FormControl>
              <FormLabel>{question}</FormLabel>
              <RadioGroup value={selected} onChange={setSelected}>
                <Stack spacing="2" mt="2">
                  {departments.map((department) => (
                    <Radio key={department.id} value={department.id}>
                      {department.name}
                    </Radio>
                  ))}
                </Stack>
              </RadioGroup>
            </FormControl>
          )}
        </ModalBody>
        <ModalFooter>
          <Flex gap="2">
            <Button variant="ghost" onClick={onCancel}>
              {t("Cancel")}
            </Button>
            <Button
              colorScheme="teal"
              isDisabled={!selected}
              isLoading={isCreating}
              onClick={() => onConfirm(selected)}
            >
              {t("Create")}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
